import empresaService, { Empresa, UsuarioEmpresa } from 'qreventos-suite/empresas';
import { CommonService } from 'qreventos-suite/src/services/common.services';

export class SeguridadService extends CommonService {

  private LOCAL_STORAGE_NAME: string = "UDATA";

  async login(mail: string, password: string): Promise<UsuarioEmpresa> {
    const usuarioEmpresa: UsuarioEmpresa = await empresaService.findUsuarioEmpresaBy(mail, password) as UsuarioEmpresa;
    if(usuarioEmpresa != null) {
      this.setItemLocalStorage(usuarioEmpresa);
    }
    return usuarioEmpresa;
  }

  async logout() {
    try {
      const usuarioEmpresa: UsuarioEmpresa = this.getLocalUsuarioEmpresa() as UsuarioEmpresa;
      if (usuarioEmpresa) {
        localStorage.removeItem(this.LOCAL_STORAGE_NAME);
      }
    } catch (error) {
      throw super.manageError(error);
    }
  }


  getLocalUsuarioEmpresa(): UsuarioEmpresa | undefined {
    const data = localStorage.getItem(this.LOCAL_STORAGE_NAME);
    if (!data) {
      return undefined;
    }

    return JSON.parse(data) as UsuarioEmpresa;
  }

  private setItemLocalStorage(usuarioEmpresa: UsuarioEmpresa) {
    localStorage.setItem(this.LOCAL_STORAGE_NAME, JSON.stringify(usuarioEmpresa))
  }
}

export default new SeguridadService();

